import axios from 'axios'
import * as Types from '../types'

export default
{
	state:
	{
		accounts: null,
		account:  null,
	},

	getters:
	{
		hasAccounts: state => state && state.accounts && state.accounts.length > 0,
		hasAccount:  state => state && state.account && !!state.account.number,
	},

	mutations:
	{
		[Types.ACCOUNTS_CLEAR](state)
		{
			state.accounts = null
		},

		[Types.ACCOUNTS_LIST](state, accounts)
		{
			state.accounts = accounts
		},

		[Types.ACCOUNT_CLEAR](state)
		{
			state.account = null
		},

        [Types.ACCOUNT_DETAILS](state, account)
		{
            state.account = account
        },
	},

	actions:
	{
		[Types.ACCOUNTS_CLEAR]({ commit })
		{
			commit(Types.ACCOUNTS_CLEAR)
		},

		[Types.ACCOUNTS_LIST]({ commit })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/accounts')
						.then
						(
							response =>
							{
								commit(Types.ACCOUNTS_LIST, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.ACCOUNT_CLEAR]({ commit })
		{
			commit(Types.ACCOUNT_CLEAR)
		},

		[Types.ACCOUNT_DETAILS]({ commit }, { accountNumber })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/accounts/' + accountNumber)
						.then
						(
							response =>
							{
								commit(Types.ACCOUNT_DETAILS, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.ACCOUNT_UPDATE]({ dispatch }, { accountNumber, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/accounts/' + accountNumber, data)
						.then
						(
							response =>
							{
								dispatch(Types.ACCOUNT_DETAILS, { accountNumber })
									.then(_ => resolve(response))
									.catch(reject)
							}
						)
						.catch(reject)
				}
			)
		},
	},
}